<h2>{{reportConfiguration?.Report.Name}}</h2>
<div style="margin-top: 15px">
  <button class="btn btn-primary" type="button" [disabled]="!isValid" (click)="runReport()" id="runButton">Run</button>
  <button class="btn btn-link" type="button" (click)="refresh()" id="resetButton">Reset to default</button>
</div>
<div class="row" style="margin-top: 15px">
  @for (parameter of reportConfiguration?.ReportParameters; track parameter.Id) {
  <div class="col-md-3">
    @switch (getParameterTypeKey(parameter.Type)) {
    @case ('bit') {
    <div class="form-group">
      <label class="control control-checkbox">
        <input type="checkbox" [ngModel]="toBool(parameter.DefaultValue)" (ngModelChange)="parameter.DefaultValue = $event ? '1' : '0'" /> <i></i>
        {{parameter.DisplayName}} *
      </label>
    </div>
    }
    @case ('int') {
    <div class="form-group">
      <label>{{parameter.DisplayName}} *</label>
      <input class="form-control" type="number" [(ngModel)]="parameter.DefaultValue" required />
    </div>
    }
    @case ('datetime') {
    <div class="form-group">
      <label>{{parameter.DisplayName}} *</label>
      <ep-datetime-picker #dateparam type="datetime" [(selectedDatetime)]="parameter.DefaultValue"></ep-datetime-picker>
    </div>
    }
    @case ('text') {
    <div class="form-group">
      <label>{{parameter.DisplayName}}</label>
      <input class="form-control" type="text" [(ngModel)]="parameter.DefaultValue" />
    </div>
    }
    }
  </div>
  }
</div>
